module.exports = __webpack_public_path__ + "252f29c7cde78dfd31bd28f8a12a9f86.pdf";